export const IMAGE_PROVIDER_OPTIONS = [
  {
    value: "bfl",
    label: "BFL Klein",
    headline: "默认稳定路线",
    description: "继续使用 FLUX 2 Klein，适合保持当前角色一致性和已有参考图节奏。",
    badge: "默认"
  },
  {
    value: "gemini",
    label: "Gemini Image",
    headline: "更快试验画面变化",
    description: "使用 gemini-3.1-flash-lite-image，适合测试更灵活的剧情画面跟随。",
    badge: "可选"
  }
] as const;

export type ImageProvider = (typeof IMAGE_PROVIDER_OPTIONS)[number]["value"];

export const DEFAULT_IMAGE_PROVIDER: ImageProvider = "bfl";

const IMAGE_PROVIDER_SET = new Set<string>(IMAGE_PROVIDER_OPTIONS.map((provider) => provider.value));

export function isImageProvider(value: unknown): value is ImageProvider {
  return typeof value === "string" && IMAGE_PROVIDER_SET.has(value);
}

export function resolveImageProvider(value: unknown, fallback: unknown = DEFAULT_IMAGE_PROVIDER): ImageProvider {
  if (isImageProvider(value)) return value;
  return isImageProvider(fallback) ? fallback : DEFAULT_IMAGE_PROVIDER;
}

export function getImageProviderConfig(value: ImageProvider) {
  return IMAGE_PROVIDER_OPTIONS.find((provider) => provider.value === value) ?? IMAGE_PROVIDER_OPTIONS[0];
}
